import React, { createContext, useCallback, useContext, useState } from 'react';

const CustomReactFlowStateContext = createContext();

export const CustomReactFlowStateProvider = ({ children }) => {
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [nodeErrors, setNodeErrors] = useState({});

  const updateIsReadOnly = useCallback((value) => {
    setIsReadOnly(value);
  }, []);

  const setNodeError = useCallback((nodeId, hasError) => {
    setNodeErrors((prev) => ({
      ...prev,
      [nodeId]: hasError,
    }));
  }, []);

  const clearNodeError = useCallback((nodeId) => {
    setNodeErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[nodeId];
      return newErrors;
    });
  }, []);

  const clearAllErrors = useCallback(() => {
    setNodeErrors({});
  }, []);

  const hasNodeError = useCallback(
    (nodeId) => {
      return !!nodeErrors[nodeId];
    },
    [nodeErrors]
  );

  return (
    <CustomReactFlowStateContext.Provider
      value={{
        isReadOnly,
        updateIsReadOnly,
        nodeErrors,
        setNodeError,
        clearNodeError,
        clearAllErrors,
        hasNodeError,
      }}
    >
      {children}
    </CustomReactFlowStateContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components -- Custom hook export is intentional
export function useCustomReactFlowState() {
  const context = useContext(CustomReactFlowStateContext);
  if (!context) {
    throw new Error('useCustomReactFlowState must be used within a CustomReactFlowStateProvider');
  }
  return context;
}
